angular.module('unergie.main')
.run((uiMaskConfig) => (uiMaskConfig.clearOnBlur = false))
